import * as React from "react";
import { Typography, Box, CircularProgress } from "@mui/material";
import { connect } from "react-redux";
import { centered_flex_box } from "../../app/components/Styles";
import { getTerms } from "../../app/store/actions/commonActions";
import ReactMarkdown from "react-markdown";
import { MarketingPage, MarketingCard } from "../../app/components/marketing";
import {
  marketingColors,
  marketingFonts,
  sectionLabelSx,
  sectionTitleSx,
} from "../../app/components/tickitMarketingTheme";

export const Terms = ({ getTerms, isLoading, terms, embedded }) => {
  React.useEffect(() => {
    getTerms();
  }, []);

  const content = (
    <Box sx={{ "& p, & li": { fontFamily: marketingFonts.body, color: marketingColors.gray600, lineHeight: 1.7 } }}>
      <ReactMarkdown>{terms}</ReactMarkdown>
    </Box>
  );

  if (isLoading) {
    return (
      <Box sx={{ ...centered_flex_box, py: embedded ? 4 : 8 }}>
        <CircularProgress sx={{ color: marketingColors.p700 }} />
      </Box>
    );
  }

  if (embedded) {
    return content;
  }

  return (
    <MarketingPage maxWidth="md">
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography sx={sectionLabelSx}>Legal</Typography>
        <Typography variant="h2" sx={{ ...sectionTitleSx, fontSize: { xs: "1.75rem", md: "2.25rem" } }}>
          Terms & Conditions
        </Typography>
      </Box>
      <MarketingCard>{content}</MarketingCard>
    </MarketingPage>
  );
};

const mapStateToProps = (state) => ({
  terms: state?.records?.results,
  isLoading: state?.records?.isLoading,
});

const mapDispatchToProps = { getTerms };

export default connect(mapStateToProps, mapDispatchToProps)(Terms);
